import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const heroImages = [
    {
      id: 1,
      src: '/sapi1.jpg',
      alt: 'Sapi berkualitas tinggi PAK MoO - Foto 1'
    },
    {
      id: 2,
      src: '/sapi2.jpg',
      alt: 'Sapi berkualitas tinggi PAK MoO - Foto 2'
    },
    {
      id: 3,
      src: '/sapi3.jpg',
      alt: 'Sapi berkualitas tinggi PAK MoO - Foto 3'
    },
    {
      id: 4,
      src: '/sapi4.jpg',
      alt: 'Sapi berkualitas tinggi PAK MoO - Foto 4'
    }
  ];

  // Auto slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="beranda" className="pt-32 md:pt-44 pb-12 md:pb-16 bg-gradient-to-br from-light-bg to-white min-h-[520px] md:min-h-[680px] xl:min-h-[800px] flex items-center overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 xl:gap-12 items-center">
          <div className="space-y-8 max-w-2xl mx-auto lg:mx-0">
            <div className="space-y-6">
              <div className="inline-flex items-center bg-accent/20 text-primary px-3 py-2 md:px-4 rounded-full text-xs sm:text-sm font-medium">
                <i className="fa-solid fa-star mr-2"></i>
                Terpercaya Sejak 2018
              </div>
              <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-primary leading-tight space-y-1 sm:space-y-0">
                <span className="block sm:inline lg:block">Mensejahterakan</span>
                <span className="block sm:inline sm:ml-2 lg:ml-0 text-secondary">Petani/Peternak</span>
                <span className="block sm:inline sm:ml-2 lg:ml-0 text-accent lg:mt-1 lg:inline-block">dan Mitra</span>
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl">
                PAK MoO hadir sebagai solusi terpercaya untuk kebutuhan hewan qurban berkualitas, organic farming, dan pemberdayaan masyarakat pedesaan dengan prinsip amanah dan berkelanjutan.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button className="bg-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-secondary transition-all duration-300 shadow-lg hover:shadow-xl">
                <i className="fa-solid fa-shopping-cart mr-2"></i>
                Lihat Produk Kami
              </button>
              <button className="border-2 border-primary text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-primary hover:text-white transition-all duration-300">
                <i className="fa-solid fa-play mr-2"></i>
                Tonton Video
              </button>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 pt-6 sm:pt-8">
              <div className="text-center bg-white/60 rounded-2xl py-4 shadow-sm">
                <div className="text-2xl sm:text-3xl font-bold text-primary">500+</div>
                <div className="text-xs sm:text-sm text-gray-600">Hewan Qurban Terjual</div>
              </div>
              <div className="text-center bg-white/60 rounded-2xl py-4 shadow-sm">
                <div className="text-2xl sm:text-3xl font-bold text-primary">50+</div>
                <div className="text-xs sm:text-sm text-gray-600">Mitra Petani</div>
              </div>
              <div className="text-center bg-white/60 rounded-2xl py-4 shadow-sm col-span-2 sm:col-span-1">
                <div className="text-2xl sm:text-3xl font-bold text-primary">98%</div>
                <div className="text-xs sm:text-sm text-gray-600">Kepuasan Pelanggan</div>
              </div>
            </div>
          </div>

          <div className="relative w-full">
            {/* Image Slider Container */}
            <div className="relative z-10 overflow-hidden rounded-3xl shadow-2xl w-full max-w-md sm:max-w-lg lg:max-w-xl mx-auto lg:mx-0">
              <div className="relative h-[260px] min-[360px]:h-[300px] sm:h-[420px] md:h-[520px] lg:h-[600px]">
                {/* Images */}
                {heroImages.map((image, index) => (
                  <div
                    key={image.id}
                    className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                      index === currentSlide ? 'opacity-100' : 'opacity-0'
                    }`}
                  >
                    <img 
                      className="w-full h-full object-cover" 
                      src={image.src} 
                      alt={image.alt}
                    />
                  </div>
                ))}

                {/* Navigation Arrows */}
                <button
                  onClick={prevSlide}
                  className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full backdrop-blur-sm transition-all duration-300 hover:scale-110"
                >
                  <i className="fa-solid fa-chevron-left text-lg sm:text-xl"></i>
                </button>
                <button
                  onClick={nextSlide}
                  className="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-2 sm:p-3 rounded-full backdrop-blur-sm transition-all duration-300 hover:scale-110"
                >
                  <i className="fa-solid fa-chevron-right text-lg sm:text-xl"></i>
                </button>

                {/* Slide Indicators */}
                <div className="absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 sm:space-x-3">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                        index === currentSlide 
                          ? 'bg-accent scale-125' 
                          : 'bg-white/50 hover:bg-white/70'
                      }`}
                    />
                  ))}
                </div>

                {/* Slide Counter */}
                <div className="absolute top-4 sm:top-6 right-4 sm:right-6 bg-black/30 text-white px-3 py-1 rounded-full text-xs sm:text-sm backdrop-blur-sm">
                  {currentSlide + 1} / {heroImages.length}
                </div>
              </div>
            </div>
            
            {/* Background Decorations */}
            <div className="absolute -top-4 sm:-top-6 -right-4 sm:-right-6 w-full h-full bg-accent/20 rounded-3xl -z-10"></div>
            <div className="absolute -bottom-4 sm:-bottom-6 -left-4 sm:-left-6 w-24 sm:w-32 h-24 sm:h-32 bg-primary/10 rounded-full -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

